var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2968 21.4998C7.54577 21.4998 4.96074 20.4288 3.01519 18.4846C1.06965 16.5404 0 13.954 0 11.2044C0 8.45338 1.071 5.86835 3.01519 3.9228C4.95939 1.97725 7.54577 0.90625 10.2968 0.90625C13.0478 0.90625 15.6328 1.97725 17.5784 3.9228C19.5239 5.86835 20.5935 8.45338 20.5935 11.2044C20.5935 13.9554 19.5225 16.5404 17.5784 18.4846C15.6342 20.4288 13.0478 21.4998 10.2968 21.4998ZM10.2968 1.99012C5.21681 1.99012 1.08387 6.12306 1.08387 11.203C1.08387 16.283 5.21681 20.4159 10.2968 20.4159C15.3767 20.4159 19.5097 16.283 19.5097 11.203C19.5097 6.12306 15.3767 1.99012 10.2968 1.99012ZM8.12903 15.5385C7.99016 15.5385 7.85129 15.4857 7.74561 15.38L4.494 12.1284C4.28265 11.917 4.28265 11.5736 4.494 11.3622C4.70536 11.1509 5.04881 11.1509 5.26016 11.3622L8.12836 14.2304L15.332 7.02673C15.5434 6.81538 15.8868 6.81538 16.0982 7.02673C16.3095 7.23809 16.3095 7.58154 16.0982 7.7929L8.5111 15.38C8.40474 15.4863 8.26587 15.5385 8.12768 15.5385H8.12903Z",
    fill: "#20016b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpTick);
export default __webpack_public_path__ + "static/media/help-tick.6dcaee95bd281529ce279f9afcf3c82e.svg";
export { ForwardRef as ReactComponent };